// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"a72c7d3b","361":"6958d9f9","374":"3ce72537","455":"f7d32a0d","644":"04f4f788","897":"137d78b2","954":"6dcc3b9a"}[chunkId] + ".chunk.js";
};